
export default {
  props: ['inCart', 'cartItem'],
  data () {
    return {
      isLoading: false,
      modalState: {
        showModal: false,
        wishlist: {
          isLoading: false
        },
        remove: {
          isLoading: false
        }
      }
    }
  },
  methods: {
    async moveToWishlist () {
      this.isLoading = true
      this.modalState.wishlist.isLoading = true
      await this.$store.dispatch('favourites/addFavourite', { diagram: this.cartItem.diagram, $backend: this.$backend, $gtag: this.$gtag, $matomo: this.$matomo })
      await this.$store.dispatch('checkout/removeDiagramFromCart', { diagram: this.cartItem.diagram, $gtag: this.$gtag, $matomo: this.$matomo })
      this.isLoading = false
      this.modalState.wishlist.isLoading = false
      this.modalState.showModal = false
    },
    async moveToCart () {
      this.isLoading = true
      await this.$store.dispatch('favourites/removeFavourite', { diagram: this.cartItem.diagram, $backend: this.$backend, $gtag: this.$gtag, $matomo: this.$matomo })
      await this.$store.dispatch('checkout/addDiagramToCart', { diagram: this.cartItem.diagram, $gtag: this.$gtag, $matomo: this.$matomo, $bing: this.$bing })
      this.isLoading = false
      this.modalState.showModal = false
    },
    async removeDiagram () {
      this.modalState.remove.isLoading = true
      if (this.inCart) {
        await this.$store.dispatch('checkout/removeDiagramFromCart', { diagram: this.cartItem.diagram, $gtag: this.$gtag, $matomo: this.$matomo })
      } else {
        await this.$store.dispatch('favourites/removeFavourite', { diagram: this.cartItem.diagram, $backend: this.$backend, $gtag: this.$gtag, $matomo: this.$matomo })
      }
      this.modalState.remove.isLoading = false
      this.modalState.showModal = false
    }
  }

}
